import { Icon, type IconVariantProp } from "~/components/icon/Icon";
import { Text } from "~/components/text/Text";
import { useLabels } from "~/hooks/useLabels";

import { Button } from "../button/Button";

import "./DownloadsCard.css";

export interface DownloadsCardProps {
  title: string;
  description: string;
  icon?: string;
  iconVariant?: IconVariantProp;
  artworkColor?: string;
  onClick?: () => void;
}

const DEFAULT_LABELS = { "card.downloads.cta": "Download" };

export function DownloadsCard({
  title,
  description,
  icon = "notebook",
  iconVariant,
  artworkColor,
  onClick,
}: DownloadsCardProps) {
  const { t } = useLabels({ fallback: DEFAULT_LABELS });

  return (
    <div
      className="DownloadsCard"
      style={{ "--card-artwork-color": artworkColor }}
    >
      <div className="DownloadsCard-artwork">
        <Icon
          icon={icon}
          variant={iconVariant}
          color="var(--color-white)"
          size="lg"
        />
      </div>

      <div className="DownloadsCard-body">
        <div className="DownloadsCard-details">
          <Text preset="title" weight="semibold">
            {title}
          </Text>
          <Text preset="description">{description}</Text>
        </div>

        <Button
          icon="circle-arrow-down"
          iconVariant="regular"
          iconPosition="left"
          size="xs"
          appearance="link"
          onClick={onClick}
        >
          {t("card.downloads.cta")}
        </Button>
      </div>
    </div>
  );
}
